/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Col, Form, Row, Tag, Tooltip } from "antd";
import { useState, useRef } from "react";
import { Input, Table, Select } from "antd";
// import Sidebar from "../../../components/AdminComponents/SideNav";
// import { useParams } from "react-router-dom";
// import {
//   ClientMenu,
//   SecondaryNavClient,
// } from "../../../components/AdminComponents/MenuItems";

import {
  // CheckOutlined,
  PlusOutlined,
  MinusOutlined,
  CheckCircleFilled,
  DeleteTwoTone,
  CloseOutlined,
  CheckOutlined,
  PlusCircleOutlined,
  // PlusCircleOutlined,
} from "@ant-design/icons";
import "../../../pages/Admin-pages/tableStyling.css";
// import ExpanedFirstRow from "./ExpandedFirstRow";

import Axios from "../../../api/Axios";
import { useSelector } from "react-redux";
import "./modalstyles.css";

import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../icons/ApplicationColor";
import EditableImage from "../../icons/EditIcon";
import ThirdCategoryChild from "./ThirdCategoryChild";

const SubCategoryChild = (props) => {
  const userInfo = useSelector((state) => state.user);

  //console.log(props.manager);

  //   const [top, setTop] = useState(false);

  // const handleParentRowClose = (key) => {
  //   setExpandedRows({
  //     ...expandedRows,
  //     [key]: true,
  //   });
  // };
  // const [secondRowIndex, setsecondRowIndex] = useState(-1);
  // const setRowSecond = (index) => {
  //   setsecondRowIndex(index);
  // };
  //

  // eslint-disable-next-line no-unused-vars
  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <MinusOutlined onClick={(e) => onExpand(record, e)} />
    ) : (
      <PlusOutlined onClick={(e) => onExpand(record, e)} />
    );
  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [applications, setApplications] = useState([]);
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <Select placeholder="Select Manager" disabled={!props.active}>
          <Select.Option key={"null"} value={"none"}>
            None
          </Select.Option>
          {props.manager?.map((app) => (
            <Select.Option key={app.id} value={app.id}>
              {app.full_name}
            </Select.Option>
          ))}
        </Select>
      ) : (
        <Input disabled={!props.active} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={
              dataIndex === "entity_id"
                ? [
                    {
                      validator: true,
                      validateTrigger: "onChange",
                    },
                  ]
                : dataIndex !== "manager"
                ? [
                    {
                      required: true,
                      message: `Please Input ${title}!`,
                    },
                  ]
                : undefined // ✅ explicitly set undefined for 'manager'
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const onFinish21 = async (values) => {
    const row = await form.validateFields();
    row.id = values.id;
    row.status = true;
    row.organization = userInfo.data.organization.id;
    row.created_by = userInfo?.data?.id;
    row.category = props?.record?.id;
    console.log(row);

    try {
      await Axios.put(`/secondcategoryedit/${values.id}/`, row, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      props.CreateSuccessful("Sub Category has been edited");
      // handleReset();
      cancel();
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Sub Category status has not been edited"
      );
    }
  };
  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      manager: record?.manager?.id,
    });
    setEditingKey(record.id);
  };
  const cancel = () => {
    setEditingKey("");
  };

  const handleRowClick = (record) => {
    // Navigate to the details page using React Router
    edit(record);
  };
  const [top, setTop] = useState(false);
  const columns = [
    {
      title: capitalizeWords("category"),
      dataIndex: "name",
      key: "name",
      width: 170, // set width to 150px
      editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div
            style={{ padding: "8px", paddingLeft: "30px", fontSize: "13.5px" }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: capitalizeWords("Secondary Categories"),
      dataIndex: "third_categories",
      key: "third_categories",
      width: 120, // set width to 150px
      // editable: true,
      align: "center",
      render: (third_categories) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        >
          <Tag
            color="magenta"
            style={{
              fontSize: "1.1rem",
              width: "2.5rem",
              height: "2.5rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%", // Make it a circle
              fontWeight: "600",
              padding: 0, // Remove padding for a perfect circle
            }}
          >
            {third_categories?.length || 0}
          </Tag>
        </div>
      ),
    },

    {
      title: capitalizeWords("No. Of Courses"),
      dataIndex: "courses",
      key: "courses",
      width: 150, // set width to 150px
      editable: false,
    },
    {
      title: capitalizeWords("Last Updated"),
      dataIndex: "updated_at",
      key: "updated_at",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div style={{ fontSize: "13.5px" }}>{formatDateWithSuffix(text)}</div>
        );
      },
    },
    {
      title: capitalizeWords("Created At"),
      dataIndex: "created_at",
      key: "created_at",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => {
        // Render logic for the manager column
        return (
          <div style={{ fontSize: "13.5px" }}>{formatDateWithSuffix(text)}</div>
        );
      },
    },
    ...(props?.ImpersonateAccess
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "operation",
            width: 80,
            align: "center",
            render: (_, record) => {
              //console.log(record);
              const editable = isEditing(record);
              return editable ? (
                <div>
                  {props.active && (
                    <CheckCircleFilled
                      title="submit"
                      style={{
                        color: "#52c41a",
                        fontSize: "1.8rem",
                        fontWeight: "700",
                      }}
                      onClick={() => onFinish21(record)}
                    />
                  )}

                  <CloseOutlined
                    onClick={() => {
                      cancel();
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                  />
                </div>
              ) : (
                <>
                  <Tooltip title={`EDIT`}>
                    <div style={{ marginLeft: "2.5px" }}>
                      <EditableImage
                        handleRowClick={handleRowClick}
                        recordId={record}
                        disabled={editingKey !== ""}
                      />
                    </div>
                  </Tooltip>
                </>
              );
            },
          },
        ]
      : []),
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "manager" ? "select" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // const data = [
  //   {
  //     key: "0",
  //     name: "Screen",
  //     platform: "iOS",
  //     version: "10.3.4.5654",
  //     upgradeNum: 500,
  //     creator: "Jack",
  //     createdAt: "Willows",
  //   },
  //   {
  //     key: "1",
  //     name: "Screen 2",
  //     platform: "Android",
  //     version: "11.0.0",
  //     upgradeNum: 1000,
  //     creator: "Jane",
  //     createdAt: "Oak",
  //   },
  //   {
  //     key: "2",
  //     name: "Screen 3",
  //     platform: "Web",
  //     version: "2.1.0",
  //     upgradeNum: 200,
  //     creator: "John",
  //     createdAt: "Maple",
  //   },
  // ];

  //console.log(namingData);

  // eslint-disable-next-line no-unused-vars

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");
  const formRef2 = useRef();
  const handleReset = () => {
    formRef2.current.resetFields();
    // props.LoadUser();
  };
  const [form1] = Form.useForm();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const onFinish2 = async (values) => {
    //console.log(values);
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        // Check if the value is undefined
        if (values[key] === undefined) {
          // Update undefined value to null
          values[key] = null;
        }
      }
    }
    values.organization = userInfo.data.organization.id;
    values.created_by = userInfo?.data?.id;
    values.status = true;
    values.category = props?.record?.id;
    try {
      await Axios.post("/secondcategorycreate/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setTop(false);
      handleReset();
      props.CreateSuccessful("Secondary Category has been created");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Secondary Category has not been created"
      );
    }
  };
  return (
    <>
      <Form form={form} component={false} style={{ margin: 0, padding: 0 }}>
        <div className="my-custom-table-wrapper">
          <Table
            bordered
            pagination={false}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            columns={mergedColumns}
            dataSource={props.data}
            style={{ margin: 0, padding: 0 }}
            expandable={{
              expandIcon,
              onExpand: (expanded, record) => {
                setExpandedRowKeys((prevKeys) => {
                  if (expanded) {
                    return [...prevKeys, record.id];
                  } else {
                    return prevKeys.filter((key) => key !== record.id);
                  }
                });
              },
            }}
            rowKey="id"
            expandedRowRender={(record, index) => {
              return (
                <ThirdCategoryChild
                  record={record}
                  data={props.data[index]?.third_categories}
                  CreateSuccessful={props.CreateSuccessful}
                  CreateFailed={props.CreateFailed}
                  LoadUser={props.LoadUser}
                  active={props.active}
                  ImpersonateAccess={props?.ImpersonateAccess}
                />
              );
            }}
            rowClassName={(record, index) =>
              expandedRowKeys.includes(record.id)
                ? "editable-row expanded-row-table-row-2"
                : "editable-row expanded-row-table-row-2"
            }
            showHeader={false}
            className="expanded-row-table-row-2"
            expandableRowIcon={<PlusOutlined type="right" />}
            collapsedRowIcon={<PlusOutlined type="down" />}
          />
        </div>
        {!top ? (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              padding: "1rem",
            }}
          >
            <Button
              onClick={() => {
                setTop(true);
              }}
              disabled={!props?.ImpersonateAccess}
              style={{
                background: "white",
                fontWeight: "500",
                fontSize: "1.35rem",
                marginLeft: "9rem",
              }}
            >
              <PlusCircleOutlined style={{ color: "magenta" }} />
              Add Sub Category
            </Button>
          </div>
        ) : (
          <div
            style={{
              marginLeft: "8rem",
              padding: "1rem",
              width: "100%",
            }}
          >
            <Form onFinish={onFinish2} ref={formRef2} form={form1}>
              <Row gutter={10} style={{ marginLeft: "0.5rem" }}>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Sub Category Name is required",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Sub Category Name" name="name" />
                  </Form.Item>
                </Col>

                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <Form.Item>
                    <div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "1.8rem",
                              height: "1.8rem",
                              borderRadius: "50%",
                              backgroundColor: "#52c41a",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CheckOutlined
                              title="submit"
                              style={{
                                color: "#fff",
                                fontSize: "1.2rem",
                                fontWeight: "700",
                              }}
                            />
                          </div>
                        </div>
                      </Button>
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.7rem",
                          marginLeft: "0.9rem",
                        }}
                        title="delete"
                        twoToneColor="#eb2f96"
                        onClick={() => {
                          setTop(false);
                          // handleReset();
                        }}
                      />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </Form>
    </>
  );
};

export default SubCategoryChild;
